import React from "react";
import "../assets/styles.css";

import ServicesRecycling from '../assets/pad-pro-services-recycling.png';
import ServicePackaging from '../assets/pad-pro-services-packaging-one.png';
import ServicePackagingTwo from '../assets/pad-pro-services-packaging-two.png';
import ServiceAdaptPark from '../assets/pad-pro-services-adapt-a-park.png';
import ServicesSorting from '../assets/pad-pro-services-sorting.png';
import ServicesMaintenance from '../assets/pad-pro-services-maintenance.png';
import ServicesRecreation from '../assets/pad-pro-services-recreation.png';
import ServicesTours from '../assets/pad-pro-services-tours.png';

export default function ServicesSectionB() {
  const services = [
    {
      id: 1,
      title: "Recycling",
      description: "Recycling - Aluminum, glass, plastic, paper, corrugates",
      image: ServicesRecycling
    },
    {
      id: 2,
      title: "Packaging",
      description: "Stacking/bundling",
      image: ServicePackagingTwo
    },
    {
      id: 3,
      title: "Packaging",
      description: "Labeling, re-labeling",
      image: ServicePackaging
    },
    {
      id: 4,
      title: "Adapt → Park",
      description: "Out of City Tours",
      image: ServiceAdaptPark
    },
    {
      id: 5,
      title: "Sorting",
      description: "Parts Sorting",
      image: ServicesSorting
    },
    {
      id: 6,
      title: "Maintenance",
      description: "Yard and grounds area backyard pottery, maintenance and pool greenhouse",
      image: ServicesMaintenance
    },
    {
      id: 7,
      title: "Recreation",
      description: "Activities, dancing and exercises, leisure sports like bowling group",
      image: ServicesRecreation
    },
    {
      id: 8,
      title: "Tours",
      description: "Library, museum and park tours and visits",
      image: ServicesTours
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white" data-aos="fade-up" data-aos-duration="1000">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Section Header - Enhanced responsive design */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-black mb-4 sm:mb-6 newsreader leading-tight">
            What we Offer
          </h2>
          <p className="text-sm sm:text-base lg:text-lg xl:text-md text-black max-w-4xl mx-auto leading-relaxed px-4 sm:px-0">
            Piedmont Adult Day Program offers the following services in pre-vocational development and community integration:
          </p>
        </div>

        {/* Services Grid - Enhanced responsive layout */}
        <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="bg-white rounded-lg border border-gray-200 shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Service Image - Enhanced responsive sizing */}
              <div className="h-40 sm:h-48 lg:h-52 xl:h-56 overflow-hidden bg-gray-100 relative">
                <img
                  src={service.image}
                  alt={`${service.title} - ${service.description}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                {/* Overlay for better visual appeal */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              {/* Service Content - Enhanced spacing and typography */}
              <div className="p-4 sm:p-5 lg:p-6">
                <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900 mb-3 sm:mb-4 text-center leading-tight">
                  {service.title}
                </h3>
                
                {/* Divider */}
                <hr className="border-gray-200 mb-3 sm:mb-4" />
                
                <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed text-center min-h-[3rem] sm:min-h-[4rem] flex items-center justify-center">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}